export const Electricity_Source_List = (t: any) => [
  {
    Header: t("Farm Code"),
    accessor: "farm_code",
  },
  {
    Header: t("Field Code"),
    accessor: "field_code",
  },
  {
    Header: t("GeneratorCode"),
    accessor: "generator_code",
  },
  {
    Header: t("SourceType"),
    accessor: "electricity_source_type",
    Cell: ({ cell: { value } }) => {
      return t(value);
    },
  },
  {
    Header: t("IntegrationDate"),
    accessor: "integration_date",
  },
];
